import { createState } from '@hookstate/core';
import { Untracked } from '@hookstate/untracked';
import * as Yup from 'yup';

export type NewsLetterState = {
  firstName: string,
  lastName: string,
  email: string,
};

export const initialNewsLetterState = (): NewsLetterState => ({
  firstName: '',
  lastName: '',
  email: '',
});

export const newsLetterState = createState<NewsLetterState>(initialNewsLetterState());

export type NewsLetterValidationState = {
  [Key in keyof NewsLetterState]: boolean | null
};

export const initialNewsLetterValidationState = (): NewsLetterValidationState => ({
  firstName: null,
  lastName: null,
  email: null,
});

export const newsLetterValidationState = createState<NewsLetterValidationState>(initialNewsLetterValidationState());

export type NewsLetterTouchedState = {
  [Key in keyof NewsLetterState]: boolean
}

export const initialNewsLetterTouchedState = (): NewsLetterTouchedState => ({
  firstName: false,
  lastName: false,
  email: false,
});

export const newsLetterTouchedState = createState<NewsLetterTouchedState>(initialNewsLetterTouchedState());

export const newsLetterValidation = Yup.object().shape({
  firstName: Yup.string().required(),
  lastName: Yup.string().required(),
  email: Yup.string().email().required(),
});

export const resetNewsLetterStates = () => {
  newsLetterState.set(initialNewsLetterState());
  newsLetterValidationState.set(initialNewsLetterValidationState());
  newsLetterTouchedState.set(initialNewsLetterTouchedState());
};

export const validateNewsLetterSyncAt = (name: string) => {
  try {
    newsLetterValidation.validateSyncAt(name, Untracked(newsLetterState).get());
    newsLetterValidationState[name].set(true);
  } catch (err) {
    newsLetterValidationState[name].set(false);
  }
};

export const newsLetterSubmitErrorState = createState<any | null>(null);

export const newsLetterSubmittingState = createState<boolean>(false);

export const newsLetterSubmitSuccessState = createState<boolean>(false);

export const validateNewsLetterSync = (props: {
  touch?: boolean,
}) => {
  const {
    touch = false,
  } = props;
  if (touch === true) {
    newsLetterValidationState.keys.forEach((name) => {
      newsLetterTouchedState[name].set(true);
    });
  }
  newsLetterState.keys.forEach((name) => {
    validateNewsLetterSyncAt(name);
  });
  return newsLetterValidationState.keys.every((name) => newsLetterValidationState[name].get() === true);
};
